let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1bpnP")).then(() => parcelRequire('bDRcH'));